import { render } from "./Management.vue?vue&type=template&id=a829cd88&scoped=true"
import script from "./Management.vue?vue&type=script&lang=js"
export * from "./Management.vue?vue&type=script&lang=js"

import "./Management.vue?vue&type=style&index=0&id=a829cd88&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a829cd88"]])

export default __exports__